var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoreeExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.375C3.58375 10.375 1.625 8.41625 1.625 6C1.625 3.58375 3.58375 1.625 6 1.625C8.41625 1.625 10.375 3.58375 10.375 6C10.375 8.41625 8.41625 10.375 6 10.375ZM6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37596 7.875C5.37596 7.52982 5.65579 7.25 6.00096 7.25C6.34614 7.25 6.62596 7.52982 6.62596 7.875C6.62596 8.22018 6.34614 8.5 6.00096 8.5C5.65579 8.5 5.37596 8.22018 5.37596 7.875Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43719 4.1219C5.40389 3.78893 5.66537 3.5 6 3.5C6.33463 3.5 6.59611 3.78893 6.56281 4.1219L6.3436 6.31405C6.32594 6.49057 6.1774 6.625 6 6.625C5.8226 6.625 5.67406 6.49057 5.6564 6.31405L5.43719 4.1219Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoreeExclamationCircle);
export default __webpack_public_path__ + "static/media/loree-exclamation-circle.9ac47c77872bd9d61a915038e16183c1.svg";
export { ForwardRef as ReactComponent };